import React from "react";
import * as Styled from "./styles";

interface FilterProps {
  body?: JSX.Element;
  leftbody?: JSX.Element;
  rightbody?: JSX.Element;
  children?: any;
}

/* 매출관리 */
const GOFilterContainer = (props: FilterProps) => {
  return (
    <Styled.FilterContainer className="filter_container">
      <Styled.LeftFilter className="left_filter">
        {props.leftbody}
      </Styled.LeftFilter>

      <Styled.CenterFilter className="center_filter">
        {props.body}
      </Styled.CenterFilter>

      <Styled.RightFilter className="right_filter">
        {props.rightbody}
      </Styled.RightFilter>

      {props.children && (
        <Styled.EtcRowFilter>{props.children}</Styled.EtcRowFilter>
      )}
    </Styled.FilterContainer>
  );
};

export default GOFilterContainer;
